/*
 * @Author: wangshengqiang
 * @Date: 2021-06-28 15:47:58
 * @LastEditTime: 2021-07-01 15:04:31
 * @LastEditors: wangshengqiang
 * @Description: 文本配置
 */
import React from 'react';
import './index.less';

const HealthTextEdit = props => {
  const {
    attrs,
    id
  } = props;
  const {
    text
  } = attrs;
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: "c-HtmlLabelComponent "
  }, /*#__PURE__*/React.createElement("div", {
    className: "ql-editor",
    dangerouslySetInnerHTML: {
      __html: text
    }
  }));
};

export default HealthTextEdit;